var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarCoinFilled = function SvgDollarCoinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-6.403a.75.75 0 0 1 .75.75v.864c.857.166 1.612.614 2.084 1.266a.75.75 0 0 1-1.216.88c-.283-.392-.87-.718-1.618-.718h-.286c-1.011 0-1.533.63-1.533 1.077v.078c0 .343.25.77.845 1.009l2.505 1.002c1.019.407 1.788 1.3 1.788 2.4 0 1.42-1.212 2.397-2.569 2.612v.836a.75.75 0 0 1-1.5 0v-.864c-.857-.166-1.612-.614-2.083-1.266a.75.75 0 1 1 1.215-.88c.283.392.87.718 1.618.718h.187c1.067 0 1.632-.665 1.632-1.155 0-.343-.25-.77-.845-1.009l-2.505-1.002c-1.019-.407-1.788-1.3-1.788-2.4v-.079c0-1.41 1.226-2.364 2.569-2.546v-.823a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgDollarCoinFilled;